import { UseRequest } from "./UseRequest";
import UseConfirm from "./UseConfirm";
import toastr from "toastr";

const UseDelete = async (endoint, idx, onConfirm, onSuccess, onCancel, onError, force) => {
    const params = force ? {idx, force: 1} : {idx}

    UseRequest(endoint, {
        request: {
            method: 'DELETE',
            data: params

        }
    }).then(async (response) => {

        if(response.status == 403){
            const data = await response.json()
            toastr['error'](data.message, null, {
                timeOut: 3500,
                preventDuplicates: true,
                preventOpenDuplicates: true
            });
        }

        if (response.status == 428) {
            const output = await response.json();

            UseConfirm({
                title: output.title,
                description: output.description,
                onConfirm: async () => {

                    if(typeof onConfirm == "function"){
                        onConfirm();
                    }

                    UseRequest(endoint, {
                        request: {
                            method: 'DELETE',
                            data: {idx, force: 1}

                        }
                    }).then((messages) => {
                        onSuccess()
                    });
                }
            });
        }

        onSuccess()
    })

}

export default UseDelete;